import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList } from "vue";
const _hoisted_1 = { class: "breakdown-header" };
const _hoisted_2 = {
    key: 0,
    class: "missing-month"
};
const _hoisted_3 = { class: "estimate-value" };
const _hoisted_4 = { class: "net-hero" };
const _hoisted_5 = { class: "net-hero-value" };
const _hoisted_6 = {
    key: 0,
    class: "net-hero-sub"
};
const _hoisted_7 = {
    key: 1,
    class: "net-hero-sub"
};
const _hoisted_8 = {
    key: 2,
    class: "month-on-month"
};
const _hoisted_9 = { class: "breakdown-grid" };
const _hoisted_10 = { class: "breakdown-row" };
const _hoisted_11 = { class: "value-group" };
const _hoisted_12 = { class: "value" };
const _hoisted_13 = {
    key: 0,
    class: "ytd-panel"
};
const _hoisted_14 = { class: "ytd-value" };
const _hoisted_15 = { class: "breakdown-row" };
const _hoisted_16 = { class: "value-group" };
const _hoisted_17 = { class: "value" };
const _hoisted_18 = {
    key: 0,
    class: "deductions-sublist"
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = { class: "label" };
const _hoisted_21 = {
    key: 0,
    class: "row-sub"
};
const _hoisted_22 = { class: "value-group" };
const _hoisted_23 = { class: "value" };
const _hoisted_24 = {
    key: 0,
    class: "ytd-panel"
};
const _hoisted_25 = { class: "ytd-value" };
const _hoisted_26 = {
    key: 0,
    class: "zero-note"
};
const _hoisted_27 = {
    key: 0,
    class: "breakdown-row"
};
const _hoisted_28 = { class: "value-group" };
const _hoisted_29 = { class: "value" };
const _hoisted_30 = {
    key: 0,
    class: "deductions-sublist"
};
const _hoisted_31 = { class: "label" };
const _hoisted_32 = { class: "value" };
const _hoisted_33 = { class: "breakdown-item employer-total" };
const _hoisted_34 = { class: "value" };
import { computed } from 'vue';
import { useAppState } from '@/composables/useAppState';
import { otherDeductions, formatDate } from '@/utils/payslips';
// One month's pay breakdown, shared by the mobile and desktop Payslips pages.
export default /*@__PURE__*/ _defineComponent({
    __name: 'PayslipBreakdown',
    props: {
        payslip: {},
        monthName: {},
        monthOnly: {},
        payslipCount: {},
        estimate: {},
        estimateSource: {},
        monthOnMonth: {},
        taxCodeVariant: {},
        dark: { type: Boolean }
    },
    emits: ["tax-code"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const state = useAppState();
        // Expanded rows live in app state so back (and leaving and returning) keeps them (DEV-147).
        const expandedRows = computed(() => state.payslipsExpanded);
        function toggleRow(key) {
            expandedRows.value[key] = !expandedRows.value[key];
        }
        // Only amounts taken from the member's gross pay. Zero rows rule: hide a row that's £0 this period and
        // £0 YTD, and summarise the hidden ones in one line.
        const deductionRows = computed(() => {
            const p = props.payslip;
            if (!p)
                return { shown: [], hiddenText: '' };
            const rows = [
                { key: 'tax', label: 'Tax', short: 'tax', value: p.tax, ytd: p.taxYTD },
                { key: 'national-insurance', label: 'National Insurance', short: 'NI', value: p.ni, ytd: p.niYTD },
                { key: 'salary-sacrifice', label: 'Salary Sacrifice', short: 'salary sacrifice', value: p.salarySacrifice, ytd: p.salarySacrificeYTD },
                { key: 'other-deductions', label: 'Other deductions', short: '', value: otherDeductions(p), ytd: 0 },
            ];
            const shown = rows.filter(r => r.value >= 0.005 || r.ytd >= 0.005);
            const hidden = rows.filter(r => !shown.includes(r) && r.short).map(r => r.short);
            const list = hidden.length > 1 ? `${hidden.slice(0, -1).join(', ')} or ${hidden[hidden.length - 1]}` : hidden[0];
            return { shown, hiddenText: list ? `No ${list} this month` : '' };
        });
        const deductionsTotal = computed(() => deductionRows.value.shown.reduce((sum, r) => sum + r.value, 0));
        const employerRows = computed(() => {
            const p = props.payslip;
            if (!p)
                return [];
            return [
                { key: 'employer-ni', label: 'Employer NI', value: p.employerNi },
                { key: 'employer-pension', label: 'Employer Pension', value: p.employerPension },
            ].filter(r => r.value >= 0.005);
        });
        const employerTotal = computed(() => employerRows.value.reduce((sum, r) => sum + r.value, 0));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["payslip-breakdown", { dark: _ctx.dark }])
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.monthName), 1),
                    (_ctx.taxCodeVariant)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: _normalizeClass(["tax-code", { 'tax-code--flag': _ctx.taxCodeVariant !== 'standard' }]),
                            onClick: _cache[0] || (_cache[0] = ($event) => (emit('tax-code')))
                        }, "Tax code " + _toDisplayString(_ctx.payslip.taxCode.trim()), 3))
                        : _createCommentVNode("", true)
                ]),
                (!_ctx.payslip)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createTextVNode(" No payslip for " + _toDisplayString(_ctx.monthOnly) + " yet. ", 1),
                        (_ctx.estimate)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", _hoisted_3, "About " + _toDisplayString(_unref(state).formatter.format(_ctx.estimate.gross)) + " gross (estimated)", 1),
                                _createTextVNode(" Estimated from your " + _toDisplayString(_ctx.estimateSource) + " payslip's year-to-date total. Send us your " + _toDisplayString(_ctx.monthOnly) + " payslip for exact figures. ", 1)
                            ], 64))
                            : _createCommentVNode("", true)
                    ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_4, [
                            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "net-hero-label" }, "Net Pay", -1)),
                            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(state).formatter.format(_ctx.payslip.netPay)), 1),
                            (_ctx.payslip.datePaid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Paid " + _toDisplayString(_unref(formatDate)(_ctx.payslip.datePaid)), 1))
                                : _createCommentVNode("", true),
                            (_ctx.payslipCount > 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.payslipCount) + " payslips this month", 1))
                                : _createCommentVNode("", true),
                            (_ctx.monthOnMonth)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.monthOnMonth), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", {
                                    class: "breakdown-item gross-pay",
                                    onClick: _cache[1] || (_cache[1] = ($event) => (toggleRow('gross')))
                                }, [
                                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "label" }, "Gross Pay", -1)),
                                    _createElementVNode("span", _hoisted_11, [
                                        _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(state).formatter.format(_ctx.payslip.grossPay)), 1),
                                        _createElementVNode("span", {
                                            class: _normalizeClass(["chevron", { expanded: expandedRows.value.gross }])
                                        }, "▼", 2)
                                    ])
                                ]),
                                _createVNode(_Transition, { name: "ytd" }, {
                                    default: _withCtx(() => [
                                        (expandedRows.value.gross)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "ytd-label" }, "Year to date", -1)),
                                                _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(state).formatter.format(_ctx.payslip.grossPayYTD)), 1)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                })
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("div", {
                                    class: "breakdown-item deductions-summary",
                                    onClick: _cache[2] || (_cache[2] = ($event) => (toggleRow('deductions')))
                                }, [
                                    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "label" }, "Deductions", -1)),
                                    _createElementVNode("span", _hoisted_16, [
                                        _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(state).formatter.format(deductionsTotal.value)), 1),
                                        _createElementVNode("span", {
                                            class: _normalizeClass(["chevron", { expanded: expandedRows.value.deductions }])
                                        }, "▼", 2)
                                    ])
                                ]),
                                _createVNode(_Transition, { name: "deductions" }, {
                                    default: _withCtx(() => [
                                        (expandedRows.value.deductions)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deductionRows.value.shown, (row) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: row.key,
                                                        class: "breakdown-row"
                                                    }, [
                                                        _createElementVNode("div", {
                                                            class: _normalizeClass(["breakdown-item", row.key]),
                                                            onClick: ($event) => (row.ytd && toggleRow(row.key))
                                                        }, [
                                                            _createElementVNode("span", _hoisted_20, [
                                                                _createTextVNode(_toDisplayString(row.label) + " ", 1),
                                                                (!row.value && row.ytd)
                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_unref(state).formatter.format(row.ytd)) + " so far this year", 1))
                                                                    : _createCommentVNode("", true)
                                                            ]),
                                                            _createElementVNode("span", _hoisted_22, [
                                                                _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(state).formatter.format(row.value)), 1),
                                                                (row.ytd)
                                                                    ? (_openBlock(), _createElementBlock("span", {
                                                                        key: 0,
                                                                        class: _normalizeClass(["chevron", { expanded: expandedRows.value[row.key] }])
                                                                    }, "▼", 2))
                                                                    : _createCommentVNode("", true)
                                                            ])
                                                        ], 10, _hoisted_19),
                                                        _createVNode(_Transition, { name: "ytd" }, {
                                                            default: _withCtx(() => [
                                                                (expandedRows.value[row.key] && row.ytd)
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                                                        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "ytd-label" }, "Year to date", -1)),
                                                                        _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(state).formatter.format(row.ytd)), 1)
                                                                    ]))
                                                                    : _createCommentVNode("", true)
                                                            ]),
                                                            _: 2
                                                        }, 1024)
                                                    ]));
                                                }), 128)),
                                                (deductionRows.value.hiddenText)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(deductionRows.value.hiddenText), 1))
                                                    : _createCommentVNode("", true)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                })
                            ]),
                            (employerRows.value.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                    _createElementVNode("div", {
                                        class: "breakdown-item employer-summary",
                                        onClick: _cache[3] || (_cache[3] = ($event) => (toggleRow('employer')))
                                    }, [
                                        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "label" }, "Paid by your employer", -1)),
                                        _createElementVNode("span", _hoisted_28, [
                                            _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(state).formatter.format(employerTotal.value)), 1),
                                            _createElementVNode("span", {
                                                class: _normalizeClass(["chevron", { expanded: expandedRows.value.employer }])
                                            }, "▼", 2)
                                        ])
                                    ]),
                                    _createVNode(_Transition, { name: "deductions" }, {
                                        default: _withCtx(() => [
                                            (expandedRows.value.employer)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(employerRows.value, (row) => {
                                                        return (_openBlock(), _createElementBlock("div", {
                                                            key: row.key,
                                                            class: _normalizeClass(["breakdown-item", row.key])
                                                        }, [
                                                            _createElementVNode("span", _hoisted_31, [
                                                                _createTextVNode(_toDisplayString(row.label) + " ", 1),
                                                                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "row-sub" }, "Your employer paid this on top of your salary. It doesn't come out of your pay.", -1))
                                                            ]),
                                                            _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(state).formatter.format(row.value)), 1)
                                                        ], 2));
                                                    }), 128)),
                                                    _createElementVNode("div", _hoisted_33, [
                                                        _cache[11] || (_cache[11] = _createElementVNode("span", { class: "label" }, "Total cost of employing you", -1)),
                                                        _createElementVNode("span", _hoisted_34, _toDisplayString(_unref(state).formatter.format(_ctx.payslip.grossPay + employerTotal.value)), 1)
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                    })
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ], 64))
            ], 2));
        };
    }
});
